module.exports = __webpack_public_path__ + "static/media/patient-history-1.871e48b7.pdf";